/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { ApiResponseAttribute } from '../models/api-response-attribute';
import { ApiResponseListAttribute } from '../models/api-response-list-attribute';
import { ApiResponsePagedResultAttribute } from '../models/api-response-paged-result-attribute';
import { createAttribute } from '../fn/referential-attribute-api/create-attribute';
import { CreateAttribute$Params } from '../fn/referential-attribute-api/create-attribute';
import { deleteAttributeByRef } from '../fn/referential-attribute-api/delete-attribute-by-ref';
import { DeleteAttributeByRef$Params } from '../fn/referential-attribute-api/delete-attribute-by-ref';
import { getAttributeByRef } from '../fn/referential-attribute-api/get-attribute-by-ref';
import { GetAttributeByRef$Params } from '../fn/referential-attribute-api/get-attribute-by-ref';
import { listAttribute } from '../fn/referential-attribute-api/list-attribute';
import { ListAttribute$Params } from '../fn/referential-attribute-api/list-attribute';
import { patchArchiveStatus2 } from '../fn/referential-attribute-api/patch-archive-status-2';
import { PatchArchiveStatus2$Params } from '../fn/referential-attribute-api/patch-archive-status-2';
import { searchAttribute } from '../fn/referential-attribute-api/search-attribute';
import { SearchAttribute$Params } from '../fn/referential-attribute-api/search-attribute';
import { updateAttribute } from '../fn/referential-attribute-api/update-attribute';
import { UpdateAttribute$Params } from '../fn/referential-attribute-api/update-attribute';

@Injectable({ providedIn: 'root' })
export class ReferentialAttributeApiService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getAttributeByRef()` */
  static readonly GetAttributeByRefPath = '/v1/api/ui/referential/attribute/{ref}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getAttributeByRef()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAttributeByRef$Response(params: GetAttributeByRef$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseAttribute>> {
    return getAttributeByRef(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getAttributeByRef$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAttributeByRef(params: GetAttributeByRef$Params, context?: HttpContext): Observable<ApiResponseAttribute> {
    return this.getAttributeByRef$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiResponseAttribute>): ApiResponseAttribute => r.body)
    );
  }

  /** Path part for operation `updateAttribute()` */
  static readonly UpdateAttributePath = '/v1/api/ui/referential/attribute/{ref}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateAttribute()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateAttribute$Response(params: UpdateAttribute$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseAttribute>> {
    return updateAttribute(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateAttribute$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateAttribute(params: UpdateAttribute$Params, context?: HttpContext): Observable<ApiResponseAttribute> {
    return this.updateAttribute$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiResponseAttribute>): ApiResponseAttribute => r.body)
    );
  }

  /** Path part for operation `deleteAttributeByRef()` */
  static readonly DeleteAttributeByRefPath = '/v1/api/ui/referential/attribute/{ref}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteAttributeByRef()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteAttributeByRef$Response(params: DeleteAttributeByRef$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return deleteAttributeByRef(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteAttributeByRef$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteAttributeByRef(params: DeleteAttributeByRef$Params, context?: HttpContext): Observable<void> {
    return this.deleteAttributeByRef$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `createAttribute()` */
  static readonly CreateAttributePath = '/v1/api/ui/referential/attribute';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createAttribute()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createAttribute$Response(params: CreateAttribute$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseAttribute>> {
    return createAttribute(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createAttribute$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createAttribute(params: CreateAttribute$Params, context?: HttpContext): Observable<ApiResponseAttribute> {
    return this.createAttribute$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiResponseAttribute>): ApiResponseAttribute => r.body)
    );
  }

  /** Path part for operation `searchAttribute()` */
  static readonly SearchAttributePath = '/v1/api/ui/referential/attribute/search';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `searchAttribute()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  searchAttribute$Response(params: SearchAttribute$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponsePagedResultAttribute>> {
    return searchAttribute(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `searchAttribute$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  searchAttribute(params: SearchAttribute$Params, context?: HttpContext): Observable<ApiResponsePagedResultAttribute> {
    return this.searchAttribute$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiResponsePagedResultAttribute>): ApiResponsePagedResultAttribute => r.body)
    );
  }

  /** Path part for operation `patchArchiveStatus2()` */
  static readonly PatchArchiveStatus2Path = '/v1/api/ui/referential/attribute/archive/{ref}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `patchArchiveStatus2()` instead.
   *
   * This method doesn't expect any request body.
   */
  patchArchiveStatus2$Response(params: PatchArchiveStatus2$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return patchArchiveStatus2(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `patchArchiveStatus2$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  patchArchiveStatus2(params: PatchArchiveStatus2$Params, context?: HttpContext): Observable<void> {
    return this.patchArchiveStatus2$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `listAttribute()` */
  static readonly ListAttributePath = '/v1/api/ui/referential/attribute/list';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `listAttribute()` instead.
   *
   * This method doesn't expect any request body.
   */
  listAttribute$Response(params: ListAttribute$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseListAttribute>> {
    return listAttribute(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `listAttribute$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  listAttribute(params: ListAttribute$Params, context?: HttpContext): Observable<ApiResponseListAttribute> {
    return this.listAttribute$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiResponseListAttribute>): ApiResponseListAttribute => r.body)
    );
  }

}
